export default "__VITE_ASSET__FQpppWUh__"